module.exports = __webpack_public_path__ + "img/name.bcc57d2d.png";